/*api
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {HttpService} from './http.service';
import {Asset }  from '../../../interfaces/masters/asset';

@Injectable()
export class AssetApi {
  private readonly apiController: string = 'asset';

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  getById(url : string, options?: any): Observable<Asset> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: Asset):Observable<Asset[]>{
    
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    
    return this.api.post( url, data, header);
  }

  update(url:string, data: Asset):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }

  assetRegMstList<T>(url: string, queryParams?:HttpParams): Observable<T>{
    if(!!queryParams) {
      const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
      return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryParams});
    }
    else{
      const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
      return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    }
  }

  assetRegMstById<T>(url : string, params:HttpParams): Observable<T> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:params})
  }

  assetRegMstupdate<T,R>(url:string, data:T,params:HttpParams):Observable<R>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.put( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:params});
  }

  assetRegMstAdd<T,R>(url:string, data:T ):Observable<R>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
   header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, header);
  }
}
